<template>
  <section
    v-if="productReferences.length"
    :id="uid"
    class="mx-auto max-w-screen-xxl px-2 my-6"
    :data-ga-carousel-title="title"
  >
    <pdl-carousel carousel-type="ltr" has-navigation :qaid="componentPrefix">
      <template #header>
        <pdl-heading :qaid="`${componentPrefix}-title`" :level="3" size="xl">{{ title }}</pdl-heading>
      </template>
      <pdl-carousel-slide v-for="product in productReferences" :key="product.sku">
        <product-card-item
          :product="product"
          :is-carousel="true"
          :is-compare-button-enabled="displayCompareButton"
          :is-product-references="true"
        />
      </pdl-carousel-slide>
    </pdl-carousel>
  </section>
</template>

<script>
import ProductCardItem from '@/components/containers/plp/ProductCardItem.vue';
import storefrontInstance from '@/api/instances/storefront';
import {mapState} from 'vuex';
import {trackEvent} from '@/utils/tracking.js';
import KeyValueObjectMapper from '@/utils/key-value-object-mapper.js';
import {PdlCarousel, PdlCarouselSlide} from '@pedal/pdl-carousel';
import {PdlHeading} from '@pedal/pdl-section-header';

export default {
  name: 'ProductReferencesContainer',
  components: {
    ProductCardItem,
    PdlCarousel,
    PdlCarouselSlide,
    PdlHeading,
  },
  props: {
    uid: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    productCode: {
      type: String,
      required: true,
    },
    isCompareButtonEnabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      productReferences: [],
      componentPrefix: 'product-references-carousel',
    };
  },
  computed: {
    ...mapState('backend', ['isB2Bsite', 'currencyIso']),
    displayCompareButton() {
      return !!(this.isCompareButtonEnabled && this.isB2Bsite);
    },
  },
  async mounted() {
    await this.getProductReferences();
  },
  methods: {
    async getProductReferences() {
      this.productReferences = await storefrontInstance
        .get(`/v1/api/product/${this.productCode}/product-reference?referenceTypeEnums=CROSSELLING,ACCESSORIES`)
        .then(({data}) => data.data);
      this.productReferences.forEach((product) => {
        product.images = KeyValueObjectMapper(product.assetImageList);
      });
      this.sendImpressions();
    },
    sendImpressions() {
      if (!this.productReferences?.length) return;

      const impressions = {
        ecommerce: {
          currency: this.currencyIso,
          impressions: this.productReferences.map((product, index) => {
            const productData = {
              id: product?.code,
              name: product?.name,
              price: product?.prices?.consumerPrice?.price?.low?.formatted,
              brand: product?.brandNameFull,
              category: product?.defaultCategory,
              list: this.title,
              position: index,
            };
            if (product.variantAttributesDirectory.length) {
              productData.variant = product.variantAttributesDirectory[0].options?.displayName;
            }

            return productData;
          }),
        },
      };
      trackEvent(impressions);
    },
  },
};
</script>

<style lang="scss" scoped>
.ymal-header {
  max-width: 75%;
}
</style>
